export default __webpack_public_path__ + "static/media/sweet-1.78f37735.jpg";